'use strict';

wbApp.controller('ActivitiesCtrl', ['$scope', '$translate', '$analytics', 'tenantSettingSvc', 'securitySvc', 'activitySvc', 'notificationSvc',
function ($scope, $translate, $analytics, tenantSettingSvc, securitySvc, activitySvc, notificationSvc) {
    $scope.tenantSettings = tenantSettingSvc.settings;

    $scope.semesters = activitySvc.getAllOpenForRegistration();

    $scope.tabs = [];
    $scope.tabs.activeTab = 0;

    function PrepareTabs(data) {
        for (var i = 0; i < data.length; i++) {
            var semester = data[i];
            $scope.tabs.push({
                title: semester.semesterName,
                template: "activities/activity-list-tab.html",
                activities: semester.activities
            });
        }
        $scope.tabs.activeTab = 0;
    }

    $scope.onInterestClick = function (semesterID, activity) {

        if (!securitySvc.isAuthenticated()) {
            notificationSvc.advertiseLogin();
            return;
        }

        $analytics.eventTrack('Lead');
        
        if (!!activity && !!activity.kindergartenEnrollmentFormId) {
            window.location = "/Forms/FormsResponse?formId=" + activity.kindergartenEnrollmentFormId;
        } else {
            activitySvc.registerActivityInterest(semesterID, success);
            function success() {
                notificationSvc.notifyInfo($translate.instant('TXT_ALERT_TITLE_ACTIVITY_INTEREST_REQUESTED'));
            }
        }
    }

    $scope.semesters.$promise.then(function (data) {
        PrepareTabs(data);
    });
}]);